import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchReconOrders,
  fetchCaseDetails,
  toggleCaseRecon,
  fetchItemDetails,
  updateItemRecon,
} from "services/orderrecon";

export const useReconOrders = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["recon-orders", filters],
    queryFn: () => fetchReconOrders(filters),
    enabled: !!enabled,
  });
};

export const useCaseDetails = (orderIds = [], enabled = true) => {
  return useQuery({
    queryKey: ["recon-case-details", orderIds],
    queryFn: () => fetchCaseDetails(orderIds),
    enabled: !!(enabled && orderIds.length > 0),
  });
};

export const useToggleCaseRecon = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => toggleCaseRecon(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["recon-case-details"] });
      queryClient.invalidateQueries({ queryKey: ["recon-orders"] });
    },
  });
};

export const useItemDetails = (filters = {}, enabled = true) => {
  return useQuery({
    queryKey: ["recon-item-details", filters],
    queryFn: () => fetchItemDetails(filters),
    enabled: !!(
      enabled &&
      filters.orderno &&
      filters.caseno !== undefined &&
      filters.recontype
    ),
  });
};

export const useUpdateItemRecon = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => updateItemRecon(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["recon-item-details"] });
      queryClient.invalidateQueries({ queryKey: ["recon-case-details"] });
    },
  });
};
